import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Award, UserCircle2, Heart } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AppNav from "@/components/AppNav";
import { SupporterBadge } from "@/lib/badges";

export default function FanProfile() {
  const { user } = useAuth();
  const [badges, setBadges] = useState(null);

  useEffect(() => {
    api.get("/fan/badges/me").then(({ data }) => setBadges(data)).catch(() => setBadges([]));
  }, []);

  return (
    <div className="flex bg-[#0D0D0D] min-h-screen text-white">
      <AppNav />
      <main className="flex-1 p-5 sm:p-8 pb-24 md:pb-8 overflow-x-hidden">
        <div className="max-w-2xl mx-auto">
          {/* Header */}
          <div className="flex items-center gap-4 mb-8" data-testid="fan-profile-header">
            <div className="w-16 h-16 rounded-full bg-[#E91E8C]/15 flex items-center justify-center shrink-0">
              <UserCircle2 className="w-9 h-9 text-[#E91E8C]" />
            </div>
            <div>
              <h1 className="text-2xl font-black font-heading">{user?.display_name}</h1>
              <p className="text-white/50 text-sm capitalize">{user?.role}</p>
            </div>
          </div>

          {/* I miei riconoscimenti */}
          <div className="mb-8">
            <div className="flex items-center gap-2 mb-3">
              <Award className="w-5 h-5 text-[#F5C6D6]" />
              <h2 className="font-bold font-heading">I miei riconoscimenti</h2>
            </div>
            {badges === null ? (
              <div className="flex justify-center py-12"><Loader2 className="w-7 h-7 text-[#E91E8C] animate-spin" /></div>
            ) : badges.length === 0 ? (
              <div className="text-center py-10 px-5 text-white/50 bg-[#1A1A1A] border border-white/10 rounded-3xl" data-testid="fan-badges-empty">
                <Heart className="w-8 h-8 mx-auto mb-3 text-[#E91E8C]" />
                Non hai ancora riconoscimenti. Sostieni i tuoi creator preferiti (abbonamenti e sblocchi) per sbloccare i badge Bronzo, Argento e Oro.
              </div>
            ) : (
              <div className="space-y-2.5" data-testid="fan-badges-list">
                {badges.map((b) => (
                  <div key={b.creator_id} data-testid={`fan-badge-${b.creator_id}`} className="bg-[#1A1A1A] border border-white/10 rounded-2xl p-4">
                    <Link to={`/creator/${b.creator_id}`} className="flex items-center gap-3 group">
                      <img src={mediaUrl(b.avatar_url)} alt={b.display_name} className="w-11 h-11 rounded-full object-cover border border-white/10" />
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-sm truncate group-hover:text-[#E91E8C] transition-colors">{b.display_name}</p>
                        <p className="text-xs text-white/40" data-testid={`fan-badge-spend-${b.creator_id}`}>Speso con questo creator: €{Number(b.spend).toFixed(2)}</p>
                      </div>
                      <SupporterBadge badge={b.badge} />
                    </Link>
                    <div className="mt-3" data-testid={`fan-badge-progress-${b.creator_id}`}>
                      {b.next_badge ? (
                        <>
                          <div className="flex items-center justify-between text-[11px] mb-1.5">
                            <span className="text-white/50">Prossimo livello: <span className="font-semibold text-[#F5C6D6]">{b.next_badge}</span></span>
                            <span className="text-white/70 font-semibold">Ti mancano €{Number(b.remaining).toFixed(2)}</span>
                          </div>
                          <div className="h-2 rounded-full bg-white/10 overflow-hidden">
                            <div className="h-full rounded-full bg-gradient-to-r from-[#E91E8C] to-[#F5C6D6] transition-all" style={{ width: `${b.progress || 0}%` }} />
                          </div>
                        </>
                      ) : (
                        <div className="flex items-center gap-1.5 text-[11px] text-amber-300 font-semibold">
                          <Award className="w-3.5 h-3.5" /> Livello massimo raggiunto
                        </div>
                      )}
                    </div>
                  </div>
                ))}
                <p className="text-[11px] text-white/30 pt-1">L'importo esatto è privato e visibile solo a te. Pubblicamente appare solo il badge.</p>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
